import {Dropdown} from 'antd';
import {Button} from '@dabafinance/react-components';
import {useNavigate} from 'react-router-dom';
import PropTypes from 'prop-types';
import styles from './newAnnouncementButton.module.scss';

/**
 * The one way to start an announcement.
 *
 * The same dropdown used to be pasted into all three tabs and both empty
 * states, so a change to the list of announcement kinds had to be made in
 * five places.
 */
export const NEW_ANNOUNCEMENT_ROUTES = [
  {
    key: 'banner',
    label: 'Banner announcement',
    to: '/dashboard/announcements/new',
  },
  {
    key: 'popup',
    label: 'Popup announcement',
    to: '/dashboard/announcements/create-popup',
  },
  {
    key: 'full-screen',
    label: 'Full screen popup',
    to: '/dashboard/announcements/create-full-screen-popup',
  },
];

export const NewAnnouncementButton = ({disabled, label, type}) => {
  const navigate = useNavigate();

  return (
    <Dropdown
      trigger={['click']}
      disabled={disabled}
      menu={{
        items: NEW_ANNOUNCEMENT_ROUTES.map(route => ({
          key: route.key,
          label: route.label,
          onClick: () => navigate(route.to),
        })),
      }}>
      {/* Dropdown injects its trigger handlers into its direct child, and the
          design-system Button does not forward them, so it keeps a wrapper. */}
      <div className={styles.trigger}>
        <Button disabled={disabled} type={type} label={label} />
      </div>
    </Dropdown>
  );
};

NewAnnouncementButton.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string,
  type: PropTypes.string,
};

NewAnnouncementButton.defaultProps = {
  disabled: false,
  label: 'New announcement',
  type: undefined,
};

export default NewAnnouncementButton;
